import React from 'react';
import { usePackageProductItem } from '@jetshop/core/hooks/PackageProducts';
import Image from '@jetshop/ui/Image';
import { Price } from '../../Price';
import ProductLink from '@jetshop/ui/ProductLink';
import { styled } from 'linaria/react';
import StockStatusIndicator from '../StockStatus/StockStatusIndicator';
import { VariantSelector } from '../VariantSelector/VariantSelector';
import { theme } from '../../Theming/Theming';
import { imageOverlay } from '../../ui/General';

const PackageProductItemWrapper = styled('div')`
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
  padding-bottom: 12px;
  color: black;
  display: flex;
  .product-link {
    min-width: 80px;
    width: 20%;
    margin-right: 1rem;
    img {
      :hover {
        opacity: 0.8 !important;
      }
    }
    ${imageOverlay}
  }

  .product-name {
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }

  .product-detail {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    ${theme.above.lg} {
      flex-direction: row;
    }
    .info {
    }
    .price {
      flex-grow: 1;
      display: flex;
      .price-quantity-wrapper {
        order: 1;
      }
      ${theme.below.md} {
        width: 100%;
        justify-content: space-between;
        align-items: flex-end;
      }
      ${theme.above.lg} {
        flex-direction: column;
        align-items: flex-end;
        .price-quantity-wrapper {
          order: 0;
        }
      }
    }
  }
  .price-quantity-wrapper {
    display: flex;
    align-items: baseline;
    .package-product-price {
      font-size: 1.1rem;
      ${theme.above.lg} {
        font-size: 1.2rem;
      }
      .price,
      .new-price,
      .old-price {
        display: inline-block;
        margin-right: 0px;
        margin-left: 8px;
      }
      .price,
      .new-price {
      }
      .old-price {
      }
    }
  }
`;

export function PackageProductItem({
  item,
  updatePackageItem,
  validationEnabled,
  price,
  fetchingPrice,
}) {
  const { stockStatus, variantHandler } = usePackageProductItem(
    item,
    updatePackageItem,
    { preselectCheapest: true }
  );

  const product = item.product;

  const { selectedVariant } = variantHandler;

  //CUSTOM FIX TO SHOW VARIANT IMAGE WHEN JUST COLOR IS SELECTED
  const variantImageSlider =
    selectedVariant ||
    (variantHandler.missingOptions?.length === 1 &&
      variantHandler.getVariantForSelection(
        variantHandler.missingOptions[0].values[0],
        variantHandler.missingOptions[0]
      ));

  const image =
    variantImageSlider && variantImageSlider.images.length
      ? variantImageSlider.images[0]
      : product?.images.length && product.images[0];

  return (
    <PackageProductItemWrapper>
      <ProductLink product={product} className="product-link">
        <Image
          sizes={[100, 200, 200, 300]}
          aspect={theme.productGrid.product.imageAspect}
          alt={image.alt}
          src={image.url}
        ></Image>
      </ProductLink>
      <div className="product-detail">
        <div className="info">
          <header>
            <h3>
              <ProductLink product={product} className="product-name">
                {product.name}
              </ProductLink>
            </h3>
            <p>{product.subName}</p>
          </header>
          {product.hasVariants && (
            <VariantSelector
              product={product}
              packageProduct={true}
              variantHandler={variantHandler}
              showValidation={validationEnabled}
              disableOutOfStock
            />
          )}
        </div>
        <div className="price">
          <div
            className="price-quantity-wrapper"
            style={{
              opacity: fetchingPrice ? 0.3 : 1,
            }}
          >
            {item.minQuantity > 1 && `${item.minQuantity} x`}
            <Price {...price} className="package-product-price" />
          </div>
          <StockStatusIndicator
            status={stockStatus.status}
            text={stockStatus.text}
            style={{ marginTop: 0 }}
          />
        </div>
      </div>
    </PackageProductItemWrapper>
  );
}
